import React, { ChangeEvent, KeyboardEvent } from 'react';

interface Props {
    value: string;
    onChange: (v: string) => void;
    formSubmitted: boolean;
    disabled: boolean;
    current?: string;
}

const LIMIT = 30;

export const TitleField = ({ value, onChange, formSubmitted, disabled, current }: Props) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value.slice(0, LIMIT));
    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        const ok = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (value.length >= LIMIT && !ok.includes(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
    };

    return (
        <div>
            <div className="relative">
                <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-eq-grey'}`}>
                    Assistant Title
                </h4>
                <span className="absolute right-0 bottom-0 text-xs text-gray-500">
                    {value.length} / {LIMIT}
                </span>
            </div>
            <p className={`text-sm mt-1 mb-4 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
                Give your custom assistant a unique name so it's easy to identify.
            </p>
            {current !== undefined && (
                <p className={`text-sm mb-2 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
                    Current Title: {current}
                </p>
            )}
            <input
                type="text"
                
                className={`mt-1 block w-full rounded-md p-3 border ${disabled ? 'text-gray-400' : 'text-bdo-gray'} ${formSubmitted && !value ? 'border-eq-green' : 'border-gray-400 focus:border-eq-green focus:ring-eq-green'}`}
                placeholder={formSubmitted && !value ? 'A title is required…' : 'Enter assistant title here…'}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
            />
        </div>
    );
};
